import $ from 'jquery'
import manager from '../manager'
import { INTERFACE } from '@/utils/INTERFACE';
import {getParams} from '@/utils/urlQuery'

manager.add('nav', {
	async created(id) {
		let $dom = $(this.dom);
		var keyword=getParams().keyword
		if(keyword){
			$dom.find(".J_nav-keyword").val(keyword)
		}
		let searchUrl = INTERFACE().mall.search.pc($('#J_venderId').val())
		$dom.find(".J_nav-search-btn")
		const jump = () => {
			let url = searchUrl + '?keyword=' + $dom.find('.J_nav-keyword').val();
			location.href=url
			// window.open(url);
		}
		$dom.find('.J_nav-search-btn').on('click', function () {
			jump()
		});
		$dom.find(".J_nav-keyword").on("keypress", e => {
			if (e.keyCode == "13") {
				jump();
			}
		})
		if (!$dom.find('.J_cate').length) {
			return;
		}
	},
	destroyed() {
		$(this.dom).find('.J_nav-search-btn').off('click')
	}
})
